var _effectorFileName = "/builds/gmini/ui-common/src/EditIssueIFrame/iframeBuilder.tsx";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import ReactDOM from 'react-dom';
import * as zoid from '@krakenjs/zoid/dist/zoid.frameworks.js';
import { createContainer, createPrerenderContainer } from '../helpers/iframeContainer';
var instance = zoid.create({
  tag: 'edit-issue',
  url: function url(_ref) {
    var _ref$props = _ref.props,
        baseUrl = _ref$props.baseUrl,
        issueId = _ref$props.issueId;
    return "".concat(baseUrl, "/issue/edit/").concat(issueId);
  },
  dimensions: {
    width: '100%',
    height: '100%'
  },
  prerenderTemplate: function defaultPrerenderTemplate(_ref2) {
    var doc = _ref2.doc;
    return createPrerenderContainer({
      doc: doc
    });
  },
  containerTemplate: function defaultContainerTemplate(_ref3) {
    var uid = _ref3.uid,
        frame = _ref3.frame,
        prerenderFrame = _ref3.prerenderFrame,
        doc = _ref3.doc,
        event = _ref3.event,
        dimensions = _ref3.dimensions;
    return createContainer({
      uid: uid,
      frame: frame,
      prerenderFrame: prerenderFrame,
      doc: doc,
      event: event,
      dimensions: dimensions
    });
  }
});
export var ReactInstance = instance.driver('react', {
  React: React,
  ReactDOM: ReactDOM
});